<template>
  <userPagesHeader :icon="profile" title="" />
  <div class="busines_register_form2">
    <p>تست</p>
    <div class="input_box">
      <label for="marketer_name">نام ویزیتور:</label>
      <input id="marketer_name" type="text" disabled />
    </div>

    <div class="input_box">
      <label for="marketer_code">کد ویزیتور:</label>
      <input id="marketer_code" type="text" disabled />
    </div>
    <div class="input_box">
      <label for="marketer_code">تاریخ:</label>
      <input id="marketer_code" type="text" disabled />
    </div>
    <button class="">اطلاعات</button>
    <hr />

    <div class="input_box">
      <label for="marketer_code">نام و نام خانوادگی</label>
      <input id="marketer_code" type="text" />
    </div>
    <div class="input_box">
      <label for="marketer_code">نام واحد صنفی</label>
      <input id="marketer_code" type="text" />
    </div>
    <div class="input_box">
      <label for="marketer_code">استان:</label>
      <select name="state" id="state">
        <option v-for="(item, index) in state" :key="index" :value="index">
          {{ item }}
        </option>
      </select>
    </div>
    <div class="input_box">
      <label for="marketer_code">شهر:</label>
      <select name="state" id="state">
        <option v-for="(item, index) in state" :key="index" :value="index">
          {{ item }}
        </option>
      </select>
    </div>
    <div class="input_box">
      <label for="busines_address">آدرس:</label>
      <input id="busines_address" type="text" />
    </div>
    <p>{{ center }}</p>
    <div class="map_div">
      <label for="busines_tel">لوکیشن:</label>

      <l-map
        v-if="lat && long"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
      >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-marker ref="marker" :lat-lng="MakeLatLng(lat, long)"> </l-marker>
        <div class="fullScreen-map">
          <i class="far fa-expand fa-lg"></i>
        </div>
      </l-map>
    </div>
    <div>
      <button @click="getLocation">مکان فعلی</button>
    </div>
    <div class="input_box">
      <label for="busines_tel">تلفن ثابت:</label>
      <input id="busines_tel" type="tel" />
    </div>
    <div class="input_box">
      <label for="busines_mobile">تلفن همراه:</label>
      <input id="busines_mobile" type="tel" />
    </div>

    <div class="input_box">
      <label for="busines_activity_category">دسته فعالیت:</label>
      <select name="forma" id="state">
        <option v-for="(item, index) in state" :key="index" :value="index">
          {{ item }}
        </option>
      </select>
    </div>

    <div class="input_box">
      <label for="busines_plan">طرح عضویت:</label>
      <select name="forma" id="busines_plan">
        <option v-for="(item, index) in plan" :key="index" :value="index">
          {{ item }}
        </option>
      </select>
    </div>

    <div class="input_box">
      <label for="marketer_code">مقدار قابل پرداخت:</label>
      <input id="price" disabled type="number" />
    </div>
    <button class="qrcode_scan_btn">اسکن QRcode</button>
    <hr />

    <div class="profile-gallery-image">
      <p style="margin-top: 0.4rem; text-align: 1rem">تصاویر محل</p>
      <UploadImageMulti @uploadSuccess="addToGallery" />
    </div>
    <div class="profile-cover-image">
      <p style="margin-top: 0.4rem; margin-bottom: 1rem">تصویر مدیر</p>
      <UploadImage @uploadSuccess="setAsCover" />
      <img />
    </div>
    <hr />
    <div class="input_box">
      <label for="marketer_code">کد تخفیف:</label>
      <input id="price" type="number" />
    </div>
    <button class="register_btn">ثبت</button>
  </div>
</template>
<script>
import userPagesHeader from "@/components/userPagesHeader/index.vue";
import UploadImage from "@/modules/upload/components/UploadImage.vue";
import UploadImageMulti from "@/modules/upload/components/UploadImageMulti.vue";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";
import { latLng } from "leaflet";
export default {
  name: "businesRegisterPage",
  mixins: [],
  components: {
    userPagesHeader,
    UploadImage,
    UploadImageMulti,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      name: "متن",
      selected: "2",
      options: ["1", "2", "3", "4"],

      zoom: 15,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      currentZoom: 11.5,
      lat: "36.3747023",
      long: "59.5105776",
      center: [36.3747023, 59.5105776],
      mapOptions: {
        zoomSnap: 0.5,
      },

      state: ["تهران", "خراسان"],
      plan: ["پلن 1", "پلن 2"],
    };
  },
  methods: {
    MakeLatLng(lat, lng) {
      // console.log("sdafdafasdfsdfadasf", lat, lng);
      if (lat && lng) return latLng(lat, lng);
      // return latLng(36.3021147, 59.5942672);
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },

    showPosition(position) {
      let myLocation =
        "Latitude: " +
        position.coords.latitude +
        "<br>Longitude: " +
        position.coords.longitude;
      alert(myLocation);
    },
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/pages/businesRegister/businesRegister.css);
</style>